import { create } from 'zustand';
import { PositionSelectType } from '@/utils/constant';

interface PositionSearchVal {
  searchType: PositionSelectType;
  value: any;
  stopValue: any;
  vehicleValue: any;
  lat: number | null;
  lon: number | null;
  mapId: string | null;
  mapVersion: string | null;
  latitude: number | null;
  longitude: number | null;
  latlngForm?: any;
}

interface SearchStore {
  positionSearchVal: PositionSearchVal;
  rightSearchVal: any;
  stopOptionList: any[];
  vehicleOptionList: any[];
  cityList: any[];

  setPositionSearchVal: (updater: (prev: PositionSearchVal) => PositionSearchVal) => void;
  setRightSearchVal: (val: any) => void;
  setStopOptionList: (list: any[]) => void;
  setVehicleOptionList: (list: any[]) => void;
  setCityList: (list: any[]) => void;
}

const initialPosition: PositionSearchVal = {
  searchType: PositionSelectType.station,
  value: null,
  stopValue: null,
  vehicleValue: null,
  lat: null,
  lon: null,
  mapId: null,
  mapVersion: null,
  latitude: null,
  longitude: null,
  latlngForm: null,
};

export const useSearchStore = create<SearchStore>((set) => ({
  positionSearchVal: initialPosition,
  rightSearchVal: null,
  stopOptionList: [],
  vehicleOptionList: [],
  cityList: [],

  setPositionSearchVal: (updater) => set((state) => ({
    positionSearchVal: updater(state.positionSearchVal),
  })),
  setRightSearchVal: (val) => set({ rightSearchVal: val }),
  setStopOptionList: (list) => set({ stopOptionList: list }),
  setVehicleOptionList: (list) => set({ vehicleOptionList: list }),
  setCityList: (list) => set({ cityList: list }),
}));
